<template>
  <div class="text-center">
    <v-dialog v-model="enable" :scrim="false" persistent width="333px">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <strong>{{ message }}</strong>
          <v-progress-linear
            v-model="power"
            color="primary"
            height="3"
            class="mt-3"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'DisconnectDialog',
  props: {
    enable: {
      type: Boolean,
      default() {
        return false
      }
    },
    message: {
      type: String,
      default() {
        return ""
      }
    }
  },
  data() {
    return {
      power: 100
    }
  },
  methods: {
    regressiveTime(power) {
      this.power = power
      if (!power) return
      return setTimeout(() => this.regressiveTime(power - 10), 1000)
    }
  },
  watch: {
    enable(val) {
      if (val) this.regressiveTime(100)
    }
  }
}
</script>

<style scoped></style>
